import { IonButton } from '@ionic/react';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { MessageContext } from '../../contexts/MessageContext';
import { OnboardingContext } from '../../contexts/OnboardingContext';
import { onboardingAtualizarEtapa, requestService } from '../../Utils/Services';
import './OnboardingContextBanner.css';

const ETAPA_NOMES: Record<string, string> = {
    dados_estabelecimento: 'Dados do estabelecimento',
    horarios: 'Horários de funcionamento',
    forma_pagamento: 'Forma de pagamento',
    catalogo: 'Catálogo de produtos',
    configuracao_entrega: 'Configuração de entrega',
    robozinho: 'Ativação do Robozinho',
    pix_automatizado: 'Pix Automatizado',
    impressao: 'Impressão',
};

const OnboardingContextBanner: React.FC = () => {
    const history = useHistory();
    const { onboardingData, setOnboardingData, etapaAtual } = useContext(OnboardingContext);
    const { loja } = useContext(MessageContext);
    const [pulando, setPulando] = useState(false);

    if (!etapaAtual || !onboardingData || onboardingData.onboarding_concluido) {
        return null;
    }

    const etapaAtualObj = onboardingData.etapas.find(e => e.id === etapaAtual);
    if (!etapaAtualObj || etapaAtualObj.status === 'concluido') {
        return null;
    }

    const etapasConcluidas = onboardingData.etapas.filter(e => e.status === 'concluido').length;
    const totalEtapas = onboardingData.total_etapas;
    const nomeEtapa = ETAPA_NOMES[etapaAtual] || etapaAtual;

    const handlePular = () => {
        if (pulando) return;
        setPulando(true);
        const url = onboardingAtualizarEtapa.url.replace('{empresa_id}', encodeURIComponent(loja));
        requestService(
            url,
            {
                method: onboardingAtualizarEtapa.method,
                body: JSON.stringify({ etapa_id: etapaAtual, status: 'concluido' }),
                headers: [['Content-Type', 'application/json']],
            },
            history,
            (res: any) => {
                setOnboardingData(res);
                setPulando(false);
                history.goBack();
            },
            () => setPulando(false)
        );
    };

    return (
        <div className="onboarding-context-banner">
            <div className="onboarding-context-banner-left" onClick={() => {
                // history.push('/empresa/configuracao-inicial');
            }}>
                {/* <IonIcon icon={arrowBack} />
        <span>Voltar ao checklist</span> */}
                {nomeEtapa} · {etapasConcluidas}/{totalEtapas}
            </div>
            <div className="onboarding-context-banner-right">
                <IonButton
                    fill="solid"
                    size="large"
                    color="tertiary"
                    onClick={handlePular}
                >
                    {pulando ? 'Pulando...' : 'Pular etapa'}
                </IonButton>
            </div>
        </div>
    );
};

export default OnboardingContextBanner;
